import {StatisticsModalConfig} from "../types/statistics-modal-config.types";
import {
  AdvertisementInitialStatisticsModalComponent
} from "../../../../modals/advertisement-initial-statistics-modal/advertisement-initial-statistics-modal.component";
import {
  AdvertisementStatisticsModalComponent
} from "../../../../modals/advertisement-statistics-modal/advertisement-statistics-modal.component";

export const statisticsModalConfig: Record<string, StatisticsModalConfig> = {
  advertisementInitialStatistics: {
    component: AdvertisementInitialStatisticsModalComponent,
    fieldName: 'initialAdvertisementStatisticsId',
    width: '450px'
  },
  initialStatistics: {
    component: AdvertisementInitialStatisticsModalComponent,
    fieldName: 'initialAdvertisementStatisticsId',
    width: '450px'
  },
  statistics: {
    component: AdvertisementStatisticsModalComponent,
    fieldName: 'advertisementStatisticsId',
    width: '450px'
  }
}
